import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Modal,
  Box,
  Grid,
  TextField,
  Autocomplete,
  IconButton,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import toast, { Toaster } from "react-hot-toast";
import activeIcon from "../../../Assests/activeIcon.svg";
import inactiveIcon from "../../../Assests/inactiveIcon.svg";
import editIcon from "../../../Assests/editIcon.svg";
import deleteIcon from "../../../Assests/deleteIcon.svg";
import React, { useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";
import CustomerInfoModal from "./CustomerInfoModal";
import HeaderNavigation from "../../../Componants/Common/header Navigation/HeaderNavigation";
import CommonButton from "../../../Componants/Common/Button";
import CustomDatePicker from "../../../Componants/Common/Custom Date Picker/CustomDatePicker";
import SuperAdminTabs from "../../../Componants/Common/SuperAdminTabs";
import { useNavigate } from "react-router-dom";
import { Calendar } from "../../../Componants/Common/Calender";
import {
  dropdownSubscription,
  getOrganizations,
} from "../../../API Service/apiService";
import Loader from "../../../Componants/Loader/Loader";
// import { Link, useNavigate } from "react-router-dom";

import infoIcon from "../../../Assests/infoIcon.svg";
import SubscriptionModal from "./SubscriptionModal";
import dayjs from "dayjs";
import Paginate from "../../../Componants/Common/Paginate";
import { Constants } from "../../../constants/Constants";
import { formatDate } from "../../../utils/dateFormatter";
// const style = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: 400,
//   bgcolor: "background.paper",
//   border: "2px solid #000",
//   boxShadow: 24,
//   pt: 2,
//   px: 4,
//   pb: 3,
// };

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "calc(60% - 20px)",
  maxHeight: "90vh",
  overflowY: "auto",
  bgcolor: "#EFF3FE",
  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
  border: "none !important",
  borderRadius: "12px",
  p: 4,
};

const tableStyles = {
  table: {
    minWidth: 650,
    "& .MuiTableCell-root": {
      padding: "12px 16px",
    },
  },
  tableHead: {
    "& .MuiTableCell-head": {
      backgroundColor: "#32499F",
      color: "white",
      fontWeight: 600,
      textAlign: "center",
    },
  },
  tableRow: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#f5f8ff",
    },
    "&:hover": {
      backgroundColor: "#e8eeff",
    },
  },
  actionButton: {
    backgroundColor: "#32499F",
    color: "white",
    "&:hover": {
      backgroundColor: "#253a7d",
    },
  },
};

const cells1 = [
  "Client Name",
  "Company Name",
  "Subscription Plan",
  "Subscription Start ",
  "Subscription Ends ",
  "No. of Licenses",
  "Payment Due Date",
  "Status",
  "Action",
];
const cells2 = [
  "Client Name",
  "Company Name",
  "Subscription Plan",
  "Trail Start",
  "Trail End",
  "No. of Licenses",
  "Payment Due Date",
  "Status",
  "Action",
];

const rows = [
  {
    clientName: "ABC Corp",
    subscriptionPlan: "Enterprise",
    subscribedOn: "2023-01-15",
    subscriptionEndsOn: "2024-01-14",
    licenses: 50,
    paymentDue: "2024-01-10",
    status: "Active",
  },
  {
    clientName: "XYZ Pvt Ltd",
    subscriptionPlan: "Pro Plan",
    subscribedOn: "2023-06-01",
    subscriptionEndsOn: "2024-06-01",
    licenses: 20,
    paymentDue: "2023-12-15",
    status: "Active",
  },
  {
    clientName: "Global Ventures",
    subscriptionPlan: "Basic Plan",
    subscribedOn: "2022-09-20",
    subscriptionEndsOn: "2023-09-19",
    licenses: 10,
    paymentDue: "2023-09-10",
    status: "Inactive",
  },
  {
    clientName: "Tech Solutions",
    subscriptionPlan: "Enterprise",
    subscribedOn: "2023-03-12",
    subscriptionEndsOn: "2024-03-11",
    licenses: 100,
    paymentDue: "2024-03-01",
    status: "Active",
  },
];

const subscriptionTypeOptions = [
  { label: "Subscription", value: "subscription" },
  { label: "Trial", value: "trial" },
];
const statusOptions = [
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" },
];

const CreateOrganizationsView = () => {
  const [subscriptionType, setSubscriptionType] = useState("subscription");
  const [open, setOpen] = useState(false);
  const [dataSize, setDataSize] = useState(10);
  const [page, setPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(1);
  const navigate = useNavigate();
  const [startDate, setStartDate] = useState(dayjs());
  const [endDate, setEndDate] = useState(dayjs().add(1, "month"));
  const [planParams, setPlanParams] = useState({
    organizationId: "",
    noOfLicense: "",
    planPrice: "",
    subscriptionPlanId: "",
    startDate: "",
    endDate: "",
  });

  const [organizations, setOrganizations] = useState([]); // Store API data
  const [filters, setFilters] = useState({
    search: "",
    subscriptionType: "subscription",
    status: "",
    mobileNo: "",
    email: "",
    organizationId: "",
    page: 1,
    limit: 10,
  });
  const [subscriptionPlan, setSubscriptionPlan] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const fetchOrganizations = async (params = {}) => {
    try {
      setLoading(true);
      const data = await getOrganizations({
        ...params,
        page: page,
        limit: dataSize,
      });

      setOrganizations(data?.data?.organizations || []);
      setTotalRecords(data?.data?.pagination.totalRecords || 0); // Make sure your API returns total count
      toast.success(data.message);
    } catch (err) {
      setError("Failed to fetch organizations.");
      toast.error("Failed to fetch organizations.");
    } finally {
      setLoading(false);
    }
  };
  // Load data initially

  // Handle search input changes
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  // Handle dropdown selection

  const handleDropdownChange = (event, value, field) => {
    if (field === "status") {
      setFilters((prev) => ({
        ...prev,
        status: value === null ? "" : value.value, // Handle null case when clearing selection
      }));
    } else {
      setFilters((prev) => ({
        ...prev,
        [field]: value?.value || value?.label || "",
      }));
    }
  };
  // Handle Search
  const handleSearch = () => {
    setPage(1);
    fetchOrganizations(filters);
  };

  // Handle Reset (Cancel Button)
  const handleReset = () => {
    setPage(1);
    setFilters({
      search: "",
      subscriptionType: "subscription",
      status: "",
      mobileNo: "",
      email: "",
    });
    fetchOrganizations();
  };

  const handleOpen = (org) => {
    console.log(`i am clicked`);
    console.log(org);
    // if (!orgID) {
    //   toast.error("Organization it is required");
    // }

    setOpen(true);
  };

  const getSubscriptionPlan = async () => {
    try {
      setLoading(true);
      const data = await dropdownSubscription();
      console.log(data.data);
      setSubscriptionPlan(data?.data || []);
    } catch (err) {
      setError("Failed to fetch subscription plan.");
      toast.error("Failed to fetch subscription plan.");
      // console.log("error====>", err);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };
  // Generic handler for updating form fields
  const handleDateChange = (fieldName, value) => {
    // setFormData((prevState) => ({
    //   ...prevState,
    //   [fieldName]: value // Update the specific field with the new value
    // }));
  };

  // Add handleEdit function
  const handleEdit = (orgId) => {
    if (!orgId) {
      toast.error("Organization ID is required for editing");
      return;
    }
    navigate(`/createorganizations?orgID=${orgId}`);
  };
  useEffect(() => {
    getSubscriptionPlan();
  }, []);
  useEffect(() => {
    setPage(1);
  }, [filters]);
  useEffect(() => {
    fetchOrganizations(filters);
  }, [page, filters.subscriptionType]);

  return (
    <Grid container>
      <HeaderNavigation value={"Client Organization"} />
      <SuperAdminTabs />

      <Grid
        container
        sx={{
          background: "#EFF3FE",
          margin: "10px",
          width: "calc(100% - 20px)",
          borderRadius: "12px",
          padding: "20px",
          boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.05)",
        }}
      >
        {" "}
        <Grid container justifyContent={"flex-end"}></Grid>
        <Grid container gap={5}>
          <Grid item>
            <Autocomplete
              id="disable-close-on-select"
              defaultValue={{ label: "Subscription", value: "subscription" }} // Set default as an object
              options={subscriptionTypeOptions}
              getOptionLabel={(option) => option.label}
              onChange={(event, value) =>
                handleDropdownChange(event, value, "subscriptionType")
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Subscription Type"
                  variant="standard"
                  style={{ width: "12rem" }}
                />
              )}
            />
          </Grid>
          <Grid item>
            <TextField
              style={{ width: "100%" }}
              id="customer-name"
              label="Customer Name"
              variant="standard"
              name="search" // Ensure this matches state key
              value={filters.search}
              onChange={handleChange}
            />
          </Grid>
          <Grid item>
            <TextField
              style={{ width: "100%" }}
              id="customer-email"
              label="Customer Email"
              variant="standard"
              name="email" // Ensure this matches state key
              value={filters.email}
              onChange={handleChange}
            />
          </Grid>
          <Grid item>
            <TextField
              style={{ width: "100%" }}
              id="customer-mobile"
              label="Customer Mobile No."
              variant="standard"
              name="mobileNo" // Ensure this matches state key
              value={filters.mobileNo}
              onChange={handleChange}
            />
          </Grid>

          <Grid container gap={3}>
            <Grid item>
              {/* <CustomDatePicker label={"Payment Due From"} width={"90%"} /> */}
              <Calendar
                // value={formData.paymentDueFrom}
                handleChange={handleDateChange}
                fieldName="Payment Due From"
                label="Payment Due From"
              />
            </Grid>

            <Grid item>
              {/* <CustomDatePicker label={"Payment Due To"} width={"90%"} /> */}
              <Calendar
                // value={formData.paymentDueTo}
                handleChange={handleDateChange}
                fieldName="Payment Due To"
                label="Payment Due To"
              />
            </Grid>

            <Grid item>
              <Autocomplete
                id="disable-close-on-select"
                options={statusOptions}
                getOptionLabel={(option) => option.label}
                value={
                  statusOptions.find(
                    (option) => option.value === filters.status
                  ) || null
                }
                onChange={(event, value) =>
                  handleDropdownChange(event, value, "status")
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Status"
                    variant="standard"
                    style={{ width: "12rem" }}
                  />
                )}
              />
            </Grid>
            <CommonButton
              name={Constants.search}
              handleOnClick={handleSearch}
            />
            <CommonButton name={Constants.cancel} handleOnClick={handleReset} />
            <CommonButton
              name={"Create New Organization"}
              handleOnClick={() => navigate("/createorganizations")}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid
        container
        mt={5}
        sx={{
          background: "#EFF3FE",
          margin: "10px",
          width: "calc(100% - 20px)",
          borderRadius: "12px",
          padding: "20px",
          boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.05)",
        }}
      >
        {filters.subscriptionType == "subscription" && (
          <div>
            <h3>Subscription Table</h3>
            <TableContainer component={Paper} sx={{ width: "100%" }}>
              <Table
                sx={{
                  width: "100%",
                  minWidth: 650,
                  tableLayout: "fixed", // This helps with consistent column widths
                }}
                size="small"
                aria-label="simple table"
              >
                <TableHead>
                  <TableRow>
                    {cells1.map((cell, index) => (
                      <TableCell
                        key={index}
                        sx={{
                          color: "white",
                          textAlign: "center",
                          width: `${100 / cells1.length}%`, // Evenly distribute column widths
                        }}
                      >
                        {cell}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={7} align="center">
                        Loading...
                      </TableCell>
                    </TableRow>
                  ) : organizations.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={7} align="center">
                        No records found
                      </TableCell>
                    </TableRow>
                  ) : (
                    organizations.map((org, index) => (
                      <TableRow key={index}>
                        <TableCell align="center">{org.clientName}</TableCell>
                        <TableCell align="center">
                          {org.companyName || "N/A"}
                        </TableCell>
                        <TableCell align="center">
                          {org.subscriptionType || "N/A"}
                        </TableCell>
                        <TableCell align="center">
                          {formatDate(org?.subscriptionStartDate)}
                        </TableCell>
                        <TableCell align="center">
                          {formatDate(org?.subscriptionEndDate)}
                        </TableCell>
                        <TableCell align="center">
                          {org.noOfLicense || "N/A"}
                        </TableCell>
                        <TableCell align="center">
                          {org.paymentDueDate || "N/A"}
                        </TableCell>
                        <TableCell align="center">
                          <img
                            src={
                              org.subscriptionStatus ? activeIcon : inactiveIcon
                            }
                            alt="Status"
                            height="20px"
                            width="20px"
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: 1,
                              width: "100%",
                            }}
                          >
                            <IconButton
                              onClick={() => handleEdit(org._id)}
                              sx={{
                                outline: "none",
                                "&:focus": { outline: "none" },
                                padding: 0,
                              }}
                            >
                              <img
                                src={editIcon}
                                alt="Edit"
                                height="20px"
                                width="20px"
                              />
                            </IconButton>

                            <SubscriptionModal
                              open={open}
                              handleClose={handleClose}
                            />
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
        {filters.subscriptionType == "trial" && (
          <div>
            <h3>Trial Table</h3>
            <TableContainer component={Paper}>
              <Table
                sx={{ minWidth: 650 }}
                size="small"
                aria-label="simple table"
              >
                <TableHead>
                  <TableRow>
                    {cells2.map((cell, index) => (
                      <TableCell
                        key={index}
                        sx={{ color: "white", textAlign: "center" }}
                      >
                        {cell}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={7} align="center">
                        Loading...
                      </TableCell>
                    </TableRow>
                  ) : organizations.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={7} align="center">
                        No records found
                      </TableCell>
                    </TableRow>
                  ) : (
                    organizations.map((org, index) => (
                      <TableRow key={index}>
                        <TableCell align="center">{org.clientName}</TableCell>
                        <TableCell align="center">
                          {org.companyName || "N/A"}
                        </TableCell>
                        <TableCell align="center">
                          {org.subscriptionType || "N/A"}
                        </TableCell>

                        <TableCell align="center">
                          {new Date(org?.trialStartDate).toLocaleDateString(
                            "en-US",
                            {
                              year: "numeric",
                              month: "2-digit",
                              day: "2-digit",
                            }
                          ) || "NA"}
                        </TableCell>
                        <TableCell align="center">
                          {new Date(org?.trialEndDate).toLocaleDateString(
                            "en-US",
                            {
                              year: "numeric",
                              month: "2-digit",
                              day: "2-digit",
                            }
                          ) || "NA"}
                        </TableCell>
                        <TableCell align="center">
                          {org.noOfLicense || "N/A"}
                        </TableCell>
                        <TableCell align="center">
                          {org.paymentDueDate || "N/A"}
                        </TableCell>
                        <TableCell align="center">
                          <img
                            src={org.trialStatus ? activeIcon : inactiveIcon}
                            alt="Status"
                            height="20px"
                            width="20px"
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: 1,
                              width: "100%",
                            }}
                          >
                            <IconButton
                              onClick={() => handleEdit(org._id)}
                              sx={{
                                outline: "none",
                                "&:focus": { outline: "none" },
                                padding: 0,
                              }}
                            >
                              <img
                                src={editIcon}
                                alt="Edit"
                                height="20px"
                                width="20px"
                              />
                            </IconButton>
                            <CommonButton
                              name="Upgrade"
                              handleOnClick={() => handleOpen(org)}
                            />

                            <SubscriptionModal
                              open={open}
                              handleClose={handleClose}
                            />
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
      </Grid>
      <Grid
        contianer
        sx={{
          width: "100%",
        }}
      >
        <Paginate
          page={page}
          totalRecords={totalRecords}
          onPageChange={handlePageChange}
          dataSize={dataSize}
        />
      </Grid>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="subscription-modal"
        sx={{
          "& .MuiBackdrop-root": {
            backgroundColor: "transparent",
          },
        }}
      >
        <Box sx={style}>
          <Typography variant="h6" component="h2" sx={{ mb: 4 }}>
            Upgrade Subscription
          </Typography>

          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Autocomplete
                options={subscriptionTypeOptions}
                getOptionLabel={(option) => option.label}
                // value={
                //   subscriptionTypeOptions.find(
                //     (type) => type.value === formData.subscriptionType
                //   ) || null
                // }
                // onChange={(event, newValue) => {
                //   setFormData({
                //     ...formData,
                //     subscriptionType: newValue ? newValue.value : "",
                //   });
                // }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Subscription Type"
                    fullWidth
                    variant="standard"
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Calendar
                //   value={startDate}
                handleChange={(date) => setStartDate(date)}
                fieldName="startDate"
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Autocomplete
                options={subscriptionPlan}
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Subscription Plan"
                    fullWidth
                    variant="standard"
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Calendar
                //   value={endDate}
                handleChange={(date) => setEndDate(date)}
                fieldName="endDate"
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="No. of Licenses"
                type="number"
                variant="standard"
                InputProps={{
                  inputProps: { min: 1 },
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Plan Price"
                type="number"
                variant="standard"
                InputProps={{
                  startAdornment: "₹",
                  inputProps: { min: 0 },
                }}
              />
            </Grid>
          </Grid>

          <Stack
            direction="row"
            spacing={2}
            justifyContent="flex-end"
            sx={{ mt: 4 }}
          >
            <CommonButton name={"Upgrade"} />
            <CommonButton name={"Cancel"} />
          </Stack>
        </Box>
      </Modal>

      <Toaster />
      {loading && <Loader />}
    </Grid>
  );
};

export default CreateOrganizationsView;
